import { render, staticRenderFns } from "./TermoLGPD.vue?vue&type=template&id=8bc8e8d4&scoped=true&"
import script from "./TermoLGPD.vue?vue&type=script&lang=js&"
export * from "./TermoLGPD.vue?vue&type=script&lang=js&"
import style0 from "./TermoLGPD.vue?vue&type=style&index=0&id=8bc8e8d4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc8e8d4",
  null
  
)

export default component.exports